import {
  CASINO_MULTIVIEW,
  CASINO_MULTIVIEW_ENABLED_QUERY_VALUE
} from 'utils/constants/casino/url-queries';
import { getCasinoParams } from 'utils/generic/route-manipulation';

export const isCasinoSingleViewRoute = (): boolean => {
  const casinoGameParams = getCasinoParams();
  const isInMultiviewMode =
    new URLSearchParams(window.location.search).get(CASINO_MULTIVIEW) ===
    CASINO_MULTIVIEW_ENABLED_QUERY_VALUE;

  return !!casinoGameParams.gameExternalId || isInMultiviewMode;
};
